<script>
  import Home from "./Home.svelte";
  import Replay from "./Replay.svelte";

  export let page;
</script>

{#if page === "tge-hero"}
  <Replay />
{:else}
  <Home />
{/if}
